// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".refs{padding:10px}.refs .wallet{border:1px solid hsla(0,0%,100%,.35);border-radius:4px;display:inline-block;margin-bottom:20px;padding:8px 20px}.refs .wallet strong{font-size:2rem}.refs .wallet img{display:inline-block;height:24px;margin-right:4px;position:relative;top:3px;width:24px}.refs h1,.refs section{margin-bottom:40px}.refs .share-reflink{width:360px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
